import { trackEcommerce } from './core';
import {
	buildEcommerceSectionFromBasketDto,
	buildEcommerceSectionFromBasketChangeDto,
} from './utils';
import { trackingEventNames } from '../../settings/constants';

import { IBasket } from './interfaces/IBasket';
import IPaymentType from './interfaces/IPaymentType';
import { IHasBasketChangesTrackingParameters } from './interfaces/IHasBasketChangesTrackingParameters';
import { IPurchase } from './interfaces/IPurchase';
import ICheckoutVersion from './interfaces/ICheckoutVersion';

export function track_view_basket(basket: IBasket, additionalEcommerceData: object) {
	const event = {
		event: trackingEventNames.VIEW_CART,
		...buildEcommerceSectionFromBasketDto(basket, additionalEcommerceData),
	};
	trackEcommerce(event);
}

export function track_add_to_cart(basket: IHasBasketChangesTrackingParameters) {
	const event = {
		event: trackingEventNames.ADD_TO_CART,
		...buildEcommerceSectionFromBasketChangeDto(
			basket.basketChangeTrackingParameters
		),
	};
	trackEcommerce(event);
}

export function track_begin_checkout(basket: IBasket, additionalEcommerceData: object) {
	const event = {
		event: trackingEventNames.BEGIN_CHECKOUT,
		...buildEcommerceSectionFromBasketDto(basket, additionalEcommerceData),
	};
	trackEcommerce(event);
}

export function track_remove_from_cart(
	basket: IHasBasketChangesTrackingParameters
) {
	const event = {
		event: trackingEventNames.REMOVE_FROM_CART,
		...buildEcommerceSectionFromBasketChangeDto(
			basket.basketChangeTrackingParameters
		),
	};
	trackEcommerce(event);
}

export function track_add_payment_info(
	basket: IBasket,
	paymentType: IPaymentType
) {
	const event = {
		event: trackingEventNames.ADD_PAYMENT_INFO,
		...buildEcommerceSectionFromBasketDto(basket, {
			payment_type: paymentType,
		}),
	};
	trackEcommerce(event);
}

export function track_add_shipping_info(basket: IBasket) {
	const event = {
		event: trackingEventNames.ADD_SHIPPING_INFO,
		...buildEcommerceSectionFromBasketDto(basket),
	};
	trackEcommerce(event);
}

export function track_purchase(
	purchseResp: IPurchase,
	checkoutVersion: ICheckoutVersion = 'sampling_2'
) {
	const event = {
		event: trackingEventNames.PURCHASE,
		ecommerce: {...purchseResp, checkout_version: checkoutVersion}
	};
	trackEcommerce(event);
}